import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

import { TitleStyle } from './styles';

const TextStyled = styled(Text)(TitleStyle);

export default function SectionTitle({ children }) {
  return (
    <TextStyled
      color="primary"
      size="xl"
      weight="medium"
    >
      {children}
    </TextStyled>
  );
}
